import React, { useState } from 'react';
import { FaArrowDown, FaMinus, FaPlus } from 'react-icons/fa';

import {
  DateName,
  MonthName,
  TicketData,
  WeeklyName,
} from '../assets/TicketData.js';
import DotLoader from '../common/DotLoader.js';

import { isEmpty } from 'lodash';
import SitReservation from '../components/SitReservation.js';
import TicketSummary from '../components/TicketSummary.js';

const BuyTicket = () => {
  const [count, setCount] = useState(0);
  const [selectSit, setSelectSit] = useState([]);
  const [selectDate, setSelectDate] = useState({});
  const [hallList, setHallList] = useState(TicketData);
  const [selectMovieList, setSelectMovieList] = useState([]);
  const [selectMovie, setSelectMovie] = useState();
  const [slectTime, setSelectTime] = useState();
  const [selectType, setSelectType] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [showLoad, setShowLoad] = useState(false);
  const [showError, setShowError] = useState(false);
  const [inputValues, setInputValues] = useState({
    userName: '',
    phoneNumber: '',
  });

  const dateChange = (selectedItem) => {
    setSelectDate(selectedItem);
    localStorage.setItem('data', selectedItem?.id);
    const localData = localStorage.getItem('data');
    const modifyData = hallList.map((item) =>
      item.id * 1 === localData * 1
        ? { ...item, selected: !item?.selected }
        : { ...item, selected: false }
    );
    const selectMoive = hallList.filter((item) => item.id === selectedItem?.id);

    setSelectMovieList(selectMoive?.[0]?.availableMovies);
    setHallList(modifyData);
    setSelectMovie('');
    setShowLoader(true);
    setTimeout(() => {
      setShowLoader(false);
    }, 3000);
  };
  const countHandle = () => {
    if (count == 10) {
      setCount(10);
    } else {
      setCount(count + 1);
    }
  };
  const countHandleMinus = () => {
    if (count == 0) {
      setCount(0);
    } else {
      setCount(count - 1);
    }
  };
  const handleMovie = (item) => {
    setSelectMovie(item);

    setShowLoad(true);
    setTimeout(() => {
      setShowLoad(false);
    }, 3000);
  };

  const timeSchedule = ['11:15 AM', '1:15 PM', '4:15 PM', '6:15 PM'];
  const timeHandle = (item) => {
    setSelectTime(item);
  };
  const seatType = [
    {
      title: 'Premium',
      value: 'BDT 750 TK',
    },
    {
      title: 'Regular',
      value: 'BDT 250 TK',
    },
  ];

  const typeHandle = (select) => {
    setSelectType(select);
  };
  console.log(selectDate);
  return (
    <div className=' bg-[#f8eff4] mx-auto'>
      <div className='container mx-auto '>
        <div className='grid md:grid-cols-2'>
          <div className=' '>
            <div>
              <div className=' py-5'>
                <div className='flex items-center'>
                  <h2 className='font-semibold text-xl mr-2'>Location</h2>
                  <FaArrowDown size='18 ' />
                </div>
                <p className='text-[#6d1d9b]font-bold text-start'>
                  Bashundhara Shopping Mall, Panthapath
                </p>{' '}
                <br />
                <hr />
              </div>
              <div className=' py-5'>
                <h2 className='font-semibold text-xl py-2 text-start'>
                  Select Date
                </h2>

                <div className='grid md:grid-cols-5 gap-2  grid-cols-3'>
                  {hallList.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => dateChange(item)}
                      className={` bg-white  md:w-28 w-25  h-18 hover:cursor-pointer p-2 rounded-md text-left text-[#8b8f9c]  ${
                        item.selected ? 'shadow-md shadow-purple-500' : ''
                      }`}
                    >
                      <span
                        className={`text-sm ${
                          item.selected ? ' text-purple-500' : ''
                        }  `}
                      >
                        <WeeklyName name={item?.showDate} />
                      </span>{' '}
                      <br />
                      <span
                        className={`text-2xl mr-1 ${
                          item.selected ? ' text-purple-500' : ''
                        }  `}
                      >
                        <DateName name={item?.showDate} />
                      </span>
                      <span
                        className={`text-xs ${
                          item.selected ? ' text-purple-500' : ''
                        }  `}
                      >
                        <MonthName name={item?.showDate} />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              {selectDate && (
                <div className='text-left py-5 '>
                  <h2 className='font-semibold text-xl py-2'>Select Movie</h2>
                  {showLoader && (
                    <div className='inline-block'>
                      <DotLoader />
                    </div>
                  )}

                  {!showLoader && (
                    <div className='grid md:grid-cols-5 gap-2 grid-cols-3'>
                      {selectMovieList.map((item, index) => (
                        <div
                          className='cursor-pointer'
                          key={index}
                        >
                          <img
                            className={` md:w-full rounded-t-xl  ${
                              item.movie_id === selectMovie?.movie_id
                                ? 'shadow-md shadow-purple-500'
                                : ''
                            }`}
                            src={item?.profile_image}
                            alt='Image Description'
                            onClick={() => handleMovie(item)}
                          />
                          <p className=' py-2  text-xs text-gray-500 dark:text-gray-500'>
                            {item?.movie_title.slice(0, 30)}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              {selectMovie && (
                <div className='text-left py-5'>
                  <h2 className='font-semibold text-2xl py-2'>
                    Select Show Time
                  </h2>
                  {showLoad && (
                    <div className='inline-block'>
                      <DotLoader />
                    </div>
                  )}
                  {!showLoad && (
                    <div className='grid grid-cols-3 md:grid-cols-5 gap-2  rounded-md text-left '>
                      {timeSchedule.map((item, index) => (
                        <button
                          key={index}
                          onClick={() => timeHandle(item)}
                          type='button'
                          className={` rounded-md  font-semibold  ${
                            item === slectTime
                              ? ' border-blue-500  bg-blue-600 text-white '
                              : ' hover:border-blue-500 border-2 border-gray-200 hover:text-white hover:bg-blue-500   bg-white  text-gray-500 transition-all text-sm dark:border-gray-700 dark:hover:border-blue-500'
                          }  py-2`}
                        >
                          {item}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className=' grid md:grid-cols-2 md:gap-5'>
                {!isEmpty(slectTime) && (
                  <div className='text-left py-5'>
                    <h2 className='font-semibold text-xl py-2'>
                      Select Seat Type
                    </h2>
                    <div className='flex justify-between items-center bg-white  h-28 p-2 rounded-md text-left text-[#8b8f9c] '>
                      <div>
                        <div className='grid grid-cols-2 gap-5 mx-auto'>
                          {seatType.map((item, index) => (
                            <div
                              className='flex'
                              key={index}
                            >
                              <input
                                type='radio'
                                name='hs-radio-group'
                                className={`w-6 shrink-0 mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 ${
                                  selectType?.title === item?.title
                                    ? 'dark:checked:bg-blue-500 text-white'
                                    : ' '
                                }  dark:checked:border-blue-500 dark:focus:ring-offset-gray-800`}
                                id='hs-radio-group-1'
                                // checked
                                onClick={() => typeHandle(item)}
                              />

                              <label
                                htmlFor='hs-radio-group-1'
                                className='text-md text-gray-500 ml-2 dark:text-gray-400'
                              >
                                {item?.title} <br />
                                {item?.value}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {!isEmpty(selectType) && (
                  <div className='text-left py-5 '>
                    <h2 className='font-semibold text-xl py-2'>
                      Ticket Quantity
                    </h2>
                    <div className='flex justify-around items-center bg-white  h-28 p-2 rounded-md text-left text-[#8b8f9c] '>
                      <div className='flex gap-x-6 items-center text-center'>
                        <button
                          className='
      border-0'
                          onClick={countHandleMinus}
                        >
                          <FaMinus />
                        </button>
                        <span className=''>
                          {count} Tickets <br />
                          <p>Max 10 Tickets</p>
                        </span>
                        <button
                          className='border-0'
                          onClick={countHandle}
                        >
                          {' '}
                          <FaPlus />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className='text-left py-5'>
                <h2 className='font-semibold text-xl py-2'>Select Seats</h2>

                <SitReservation
                  setSelectSit={setSelectSit}
                  selectSit={selectSit}
                  count={count}
                />
              </div>
            </div>
          </div>
          <div className='flex md:justify-end justify-center mx-5 '>
            <TicketSummary
              selectMovie={selectMovie}
              selectDate={selectDate}
              slectTime={slectTime}
              selectType={selectType}
              setSelectType={setSelectType}
              count={count}
              setCount={setCount}
              selectSit={selectSit}
              setSelectDate={setSelectDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyTicket;
